// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-grant-seller-without-prati',
//   standalone: true,
//   imports: [],
  // templateUrl: './grant-seller-without-prati.component.html',
  // styleUrl: './grant-seller-without-prati.component.scss'
// })
// export class GrantSellerWithoutPratiComponent {

// }
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-grant-seller-without-prati',
  // standalone: true,
  // imports: [],
  templateUrl: './grant-seller-without-prati.component.html',
  styleUrl: './grant-seller-without-prati.component.scss'
})
export class GrantSellerWithoutPratiComponent {
   labelsData: any[] = [];
      data1: any[] = [];
    
      repNames: any = '';
      firstRepName = '';
      lastRepName = '';
      district: any = '';
      taluka: any = '';
      iscustomer: string = 'no';
      distributiveRep: string = '';
      deliveryMode: string = '';
      stateName: string = '';
    
      constructor(
        private dialogref: MatDialogRef<GrantSellerWithoutPratiComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
      ) {}
    
      ngOnInit(): void {
        // ✅ Log all incoming data to verify fields
        console.log('Dialog data received:', this.data);
        console.log('Address labels raw:', this.data?.addresslabels);
    
        this.labelsData      = this.data?.addresslabels || [];
        this.repNames        = this.data?.rep_names || '';
        this.district        = this.data?.district_name || '';
        this.taluka          = this.data?.taluka_name || '';
        this.iscustomer      = this.data?.iscustomer || 'no';       // ✅ Fixed
        this.distributiveRep = this.data?.distributive_reps || '';  // ✅ Fixed
        this.deliveryMode    = this.data?.delivery_mode || '';
        this.stateName       = this.data?.state_name || '';
    
        if (Array.isArray(this.repNames)) {
          this.firstRepName = this.repNames[0] || '';
          this.lastRepName  = this.repNames[this.repNames.length - 1] || '';
        }
    
        console.log('labelsData count:', this.labelsData.length); // ✅ Check count
        console.log('Sample record:', this.labelsData[0]);        // ✅ Check field names
    
        this.prepareData();
      }
    
      prepareData(): void {
        if (!this.labelsData.length) {
          console.warn('labelsData is empty!');
          this.data1 = [];
          return;
        }
    
        // ✅ Relaxed filter — don't block on missing address
        const cleanData = this.labelsData.filter(x => x?.name || x?.bookseller_name);
    
        console.log('After name filter count:', cleanData.length); // ✅ Debug
    
        // ✅ Normalize field names from API → template fields
        const normalizedData = cleanData.map(item => ({
          ...item,
          // Map alternate API field names to expected ones
          name:         item.name         || item.bookseller_name  || item.seller_name || '',
          address:      item.address      || item.addr             || item.address1    || '',
          taluka:       item.taluka       || item.taluka_name       || '',
          district:     item.district     || item.district_name     || '',
          state:        item.state        || item.state_name        || '',
          pincode:      item.pincode      || item.pin_code          || '',
          book_copies:  item.book_copies  || item.copies            || item.qty        || 0,
          mobile_no:    item.mobile_no    || item.mobileNumber      || item.mobile     || '',
          subno:        item.subno        || item.sub_no            || '',
          month:        item.month        || '',
          year:         item.year         || '',
        }));
    
        // Sort by pincode
        normalizedData.sort((a, b) =>
          Number(a?.pincode || 0) - Number(b?.pincode || 0)
        );
    
        const isBookSelected = this.data?.bookwise && this.data.bookwise !== '';
        const isDistRepSelected = this.distributiveRep && this.distributiveRep !== '';
    
        console.log('isBookSelected:', isBookSelected);
        console.log('isDistRepSelected:', isDistRepSelected);
    
        if (isBookSelected) {
          // CASE 1: Book selected → show all as-is
          this.data1 = normalizedData;
    
        } else {
          // CASE 2: No book → sum book_copies per bookseller
          const map = new Map();
    
          normalizedData.forEach(item => {
            const key = item.name;
            if (!map.has(key)) {
              map.set(key, { ...item, book_copies: 0 });
            }
            map.get(key).book_copies += Number(item.book_copies || 0);
          });
    
          this.data1 = Array.from(map.values());
        }
    
        console.log('Final data1 count:', this.data1.length); // ✅ Should be > 0
        console.log('Sample data1[0]:', this.data1[0]);
      }
    
      print(): void {
        document.title = 'Labels';
        window.print();
      }
    
      close(): void {
        this.dialogref.close();
      }
    }
  
  
  


